import { films } from "@/mocks/films";
import { specials } from "@/mocks/specials";
import type { Film, Special } from "@/types/content";

export function getFilmById(id: string | undefined): Film | undefined {
  if (!id) return undefined;
  return films.find((film) => film.id === id);
}

export function getSpecialById(id: string | undefined): Special | undefined {
  if (!id) return undefined;
  return specials.find((item) => item.id === id);
}

export function getFilmsByType(type: string): Film[] {
  if (type === "电影") return films.filter((film) => film.type === "电影");
  if (type === "电视剧") return films.filter((film) => film.type === "电视剧");
  return films;
}

export function getSpecialsForFilm(filmId: string): Special[] {
  return specials.filter((special) => special.filmIds.includes(filmId));
}

export function searchFilms(keyword: string): Film[] {
  const key = keyword.trim().toLowerCase();
  if (!key) return [];
  return films.filter((film) => {
    const haystack = [
      film.title,
      film.director,
      film.actors,
      film.region,
      film.intro,
      ...film.tags,
    ]
      .join(" ")
      .toLowerCase();
    return haystack.includes(key);
  });
}

export function getRelatedFilms(film: Film, limit = 5): Film[] {
  const scored = films
    .filter((item) => item.id !== film.id)
    .map((item) => {
      let score = 0;
      if (item.type === film.type) score += 2;
      const sharedTags = item.tags.filter((tag) => film.tags.includes(tag));
      score += sharedTags.length * 2;
      if (item.region === film.region) score += 1;
      return { item, score };
    })
    .sort((a, b) => b.score - a.score || b.item.popularity - a.item.popularity);
  return scored.slice(0, limit).map((entry) => entry.item);
}

export function getHotFilms(limit = 8): Film[] {
  return [...films].sort((a, b) => b.popularity - a.popularity).slice(0, limit);
}

export function getLatestFilms(limit = 10): Film[] {
  return [...films].sort((a, b) => b.year - a.year).slice(0, limit);
}

export function getFeaturedFilms(limit = 5): Film[] {
  return [...films]
    .sort((a, b) => b.rating - a.rating || b.popularity - a.popularity)
    .slice(0, limit);
}

export function getAllRegions(): string[] {
  return Array.from(new Set(films.map((film) => film.region)));
}

export function getAllLanguages(): string[] {
  return Array.from(new Set(films.map((film) => film.language)));
}

export function getAllYears(): number[] {
  return Array.from(new Set(films.map((film) => film.year))).sort((a, b) => b - a);
}